import serialize from 'serialize-javascript';

export const setLocalStorageValue = (key, value) => {
  const serializedValue = serialize(value, { ignoreFunction: true });
  localStorage.setItem(key, serializedValue);
};

export const getLocalStorageValue = (key) => {
  const serializedValue = localStorage.getItem(key);

  if (!serializedValue) {
    return null;
  }

  return JSON.parse(serializedValue);
};
